export function getCardQuestionForReviewForCorrespondingQuestion(offer, questionId) {
  for (let sectionIndex = 0; sectionIndex < (offer.children || []).length; sectionIndex += 1) {
    const section = offer.children[sectionIndex];
    for (let cardIndex = 0; cardIndex < (section.children || []).length; cardIndex += 1) {
      const card = section.children[cardIndex];
      if (card.offerType === 'peerReviewCard' && card.children) {
        for (
          let cardQuestionForReviewIndex = 0;
          cardQuestionForReviewIndex < (card.children || []).length;
          cardQuestionForReviewIndex += 1
        ) {
          const cardQuestionForReview = card.children[cardQuestionForReviewIndex];
          if (cardQuestionForReview.correspondingQuestionId === questionId) {
            return cardQuestionForReview;
          }
        }
      }
    }
  }
  return null;
}

export function getAssignmentCardForPeerReviewCard(offer, peerReviewCardId) {
  for (let sectionIndex = 0; sectionIndex < (offer.children || []).length; sectionIndex += 1) {
    const section = offer.children[sectionIndex];
    for (let cardIndex = 0; cardIndex < (section.children || []).length; cardIndex += 1) {
      const card = section.children[cardIndex];
      if (card.offerType === 'peerReviewCard' && card._id === peerReviewCardId) {
        return section.children[cardIndex - 1];
      }
    }
  }
  return null;
}

export function getPeerReviewCardForAssignmentCard(offer, assignmentCardId) {
  for (let sectionIndex = 0; sectionIndex < (offer.children || []).length; sectionIndex += 1) {
    const section = offer.children[sectionIndex];
    for (let cardIndex = 0; cardIndex < (section.children || []).length; cardIndex += 1) {
      const card = section.children[cardIndex];
      if (card.offerType === 'assignmentCard' && card._id === assignmentCardId) {
        return section[cardIndex + 1];
      }
    }
  }
  return null;
}
